import React from 'react';

import { colorsPalette } from '../../theme';
import useStyles from './styles';

const CloseIcon = (props) => {
  const color = props?.color || colorsPalette.white;
  const classes = useStyles()();
  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      {...props}
      color={color}
    >
      <line className={classes.element} x1="3" y1="21.00001" x2="21" y2="3.00001" />
      <line className={classes.element} x1="21" y1="21.00001" x2="3" y2="3.00001" />
    </svg>
  );
};

export default CloseIcon;
